// web/src/screens/NoAccess.tsx — signed in, but no invite and no website (portal spec 13 / DECISIONS X8).
import { logout } from '../lib/auth';
import { BRAND } from '../lib/brand';

export function NoAccess({ email }: { email: string }) {
  return (
    <div className="mx-auto max-w-md px-4 py-16 text-center">
      <h1 className="font-head text-xl text-ink">This dashboard is for {BRAND.name} clients</h1>
      <p className="mt-3 break-words text-sm text-muted">
        You're signed in as {email}, but there's no website set up for this account yet.
        If you were sent an invite link, open it again on this device.
      </p>
      <p className="mt-3 text-sm text-muted">
        Want a website like this? Visit <a className="underline" href="https://yourproject.ai">yourproject.ai</a>.
      </p>
      <button onClick={() => logout()} className="mt-6 inline-flex min-h-11 items-center rounded-md border border-hair px-4 text-sm text-ink">
        Sign out
      </button>
    </div>
  );
}
